export const CITIES = [
    { id: 1, slug: "tehran", title: "تهران" },
    { id: 2, slug: "karaj", title: "کرج" },
    { id: 3, slug: "mashhad", title: "مشهد" },
    { id: 4, slug: "isfahan", title: "اصفهان" },
    { id: 5, slug: "shiraz", title: "شیراز" },
    { id: 6, slug: "tabriz", title: "تبریز" },
    { id: 7, slug: "ahvaz", title: "اهواز" },
    { id: 8, slug: "qom", title: "قم" },
    { id: 9, slug: "kermanshah", title: "کرمانشاه" },
    { id: 10, slug: "urmia", title: "ارومیه" },
    { id: 11, slug: "rasht", title: "رشت" },
    { id: 12, slug: "zahedan", title: "زاهدان" },
    { id: 13, slug: "hamadan", title: "همدان" },
    { id: 14, slug: "kerman", title: "کرمان" },
    { id: 15, slug: "yazd", title: "یزد" },
    { id: 16, slug: "ardabil", title: "اردبیل" },
    { id: 17, slug: "bandar-abbas", title: "بندرعباس" },
    { id: 18, slug: "zanjan", title: "زنجان" },
    { id: 19, slug: "sanandaj", title: "سنندج" },
    { id: 20, slug: "sari", title: "ساری" },
    { id: 21, slug: "gorgan", title: "گرگان" },
    { id: 22, slug: "khorramabad", title: "خرم‌آباد" },
    { id: 23, slug: "bushehr", title: "بوشهر" },
    { id: 24, slug: "bojnurd", title: "بجنورد" },
    { id: 25, slug: "birjand", title: "بیرجند" },
    { id: 26, slug: "qazvin", title: "قزوین" },
    { id: 27, slug: "shahre-kord", title: "شهرکرد" },
    { id: 28, slug: "ilam", title: "ایلام" },
    { id: 29, slug: "yasuj", title: "یاسوج" },
    { id: 30, slug: "semnan", title: "سمنان" },
    { id: 31, slug: "arak", title: "اراک" },
    { id: 32, slug: 'sacramento', title: 'ساکرامنتو' },
    { id: 33, slug: 'austin', title: 'آستین' },
    { id: 34, slug: 'tallahassee', title: 'تلاهاسی' },
    { id: 35, slug: 'albany', title: 'آلبانی' },
    { id: 36, slug: 'springfield', title: 'اسپرینگفیلد' },
    { id: 37, slug: 'harrisburg', title: 'هریسبورگ' },
    { id: 38, slug: 'columbus', title: 'کلمبوس' },
    { id: 39, slug: 'atlanta', title: 'آتلانتا' },
    { id: 40, slug: 'raleigh', title: 'رالی' },
    { id: 41, slug: 'lansing', title: 'لنسینگ' },
    { id: 42, slug: 'trenton', title: 'ترنتون' },
    { id: 43, slug: 'richmond', title: 'ریچموند' },
    { id: 44, slug: 'olympia', title: 'المپیا' },
    { id: 45, slug: 'phoenix', title: 'فنیکس' },
    { id: 46, slug: 'boston', title: 'بوستون' },
    { id: 47, slug: 'nashville', title: 'نشویل' },
    { id: 48, slug: 'indianapolis', title: 'ایندیاناپولیس' },
    { id: 49, slug: 'jefferson-city', title: 'جفرسون سیتی' },
    { id: 50, slug: 'annapolis', title: 'آناپولیس' },
    { id: 51, slug: 'madison', title: 'مدیسون' },
    { id: 52, slug: 'denver', title: 'دنور' },
    { id: 53, slug: 'saint-paul', title: 'سنت پل' },
    { id: 54, slug: 'columbia', title: 'کلمبیا' },
    { id: 55, slug: 'montgomery', title: 'مانتگمری' },
    { id: 56, slug: 'baton-rouge', title: 'باتون-روژ' },
    { id: 57, slug: 'frankfort', title: 'فرانکفورت' },
    { id: 58, slug: 'salem', title: 'سیلم' },
    { id: 59, slug: 'oklahoma-city', title: 'اوکلاهاما سیتی' },
    { id: 60, slug: 'hartford', title: 'هارتفورد' },
    { id: 61, slug: 'salt-lake-city', title: 'سالت-لیک-سیتی' },
    { id: 62, slug: 'des-moines', title: 'دس-موینس' },
    { id: 63, slug: 'carson-city', title: 'کارسون سیتی' },
    { id: 64, slug: 'little-rock', title: 'لیتل-راک' },
    { id: 65, slug: 'jackson', title: 'جکسون' },
    { id: 66, slug: 'topeka', title: 'توپکا' },
    { id: 67, slug: 'santa-fe', title: 'سانتا-فه' },
    { id: 68, slug: 'lincoln', title: 'لینکلن' },
    { id: 69, slug: 'charleston', title: 'چارلستون' },
    { id: 70, slug: 'boise', title: 'بویز' },
    { id: 71, slug: 'honolulu', title: 'هونولولو' },
    { id: 72, slug: 'augusta', title: 'آگوستا' },
    { id: 73, slug: 'concord', title: 'کانکورد' },
    { id: 74, slug: 'providence', title: 'پراویدنس' },
    { id: 75, slug: 'helena', title: 'هلنا' },
    { id: 76, slug: 'dover', title: 'دوور' },
    { id: 77, slug: 'pierre', title: 'پیِر' },
    { id: 78, slug: 'bismarck', title: 'بیسمارک' },
    { id: 79, slug: 'juneau', title: 'جونئو' },
    { id: 80, slug: 'montpelier', title: 'مونپلیه' },
    { id: 81, slug: 'cheyenne', title: 'شایان' },
    { id: 82, slug: 'washington-dc', title: 'واشنگتن دی سی' },
    // UAE
    { id: 83, slug: 'abu-dhabi-city', title: 'ابوظبی' },
    { id: 84, slug: 'dubai-city', title: 'دبی' },
    { id: 85, slug: 'sharjah-city', title: 'شارجه' },
    { id: 86, slug: 'ajman-city', title: 'عجمان' },
    { id: 87, slug: 'umm-al-quwain-city', title: 'ام‌القیوین' },
    { id: 88, slug: 'ras-al-khaimah-city', title: 'رأس‌الخیمه' },
    { id: 89, slug: 'fujairah-city', title: 'فجیره' },
    // Saudi Arabia
    { id: 90, slug: 'riyadh-city', title: 'ریاض' },
    { id: 91, slug: 'makkah-city', title: 'مکه' },
    { id: 92, slug: 'madinah-city', title: 'مدینه' },
    { id: 93, slug: 'dammam', title: 'دمام' },
    { id: 94, slug: 'abha', title: 'ابها' },
    { id: 95, slug: 'jizan-city', title: 'جیزان' },
    { id: 96, slug: 'buraydah', title: 'بریده' },
    { id: 97, slug: 'hail-city', title: 'حائل' },
    { id: 98, slug: 'tabuk-city', title: 'تبوک' },
    { id: 99, slug: 'najran-city', title: 'نجران' },
    { id: 100, slug: 'sakakah', title: 'سکاکا' },
    { id: 101, slug: 'al-bahah-city', title: 'الباحه' },
    { id: 102, slug: 'ar-ar', title: 'عرعر' },
    // Oman
    { id: 103, slug: 'muscat', title: 'مسقط' },
    { id: 104, slug: 'nizwa', title: 'نزوی' },
    { id: 105, slug: 'ibri', title: 'عبری' },
    { id: 106, slug: 'sohar', title: 'صحار' },
    { id: 107, slug: 'rustaq', title: 'رستاق' },
    { id: 108, slug: 'al-buraimi', title: 'البریمی' },
    { id: 109, slug: 'haima', title: 'هیما' },
    { id: 110, slug: 'ibra', title: 'ابرا' },
    { id: 111, slug: 'sur', title: 'صور' },
    { id: 112, slug: 'salalah', title: 'صلاله' },
    { id: 113, slug: 'khasab', title: 'خصب' },
    // Iraq
    { id: 114, slug: 'baghdad', title: 'بغداد' },
    { id: 115, slug: 'basra', title: 'بصره' },
    { id: 116, slug: 'hillah', title: 'حله' },
    { id: 117, slug: 'baqubah', title: 'بعقوبه' },
    { id: 118, slug: 'al-nasiriyah', title: 'ناصریه' },
    { id: 119, slug: 'karbala', title: 'کربلا' },
    { id: 120, slug: 'kirkuk', title: 'کرکوک' },
    { id: 121, slug: 'amarah', title: 'عماره' },
    { id: 122, slug: 'najaf', title: 'نجف' },
    { id: 123, slug: 'mosul', title: 'موصل' },
    { id: 124, slug: 'tikrit', title: 'تکریت' },
    { id: 125, slug: 'sulaymaniyah', title: 'سلیمانیه' },
    { id: 126, slug: 'kut', title: 'کوت' },
    // Syria
    { id: 127, slug: 'damascus', title: 'دمشق' },
    { id: 128, slug: 'aleppo', title: 'حلب' },
    { id: 129, slug: 'homs', title: 'حمص' },
    { id: 130, slug: 'latakia', title: 'لاذقیه' },
    { id: 131, slug: 'tartus', title: 'طرطوس' },
    { id: 132, slug: 'hama', title: 'حماه' },
    { id: 133, slug: 'deir ez-zor', title: 'دیرالزور' },
    { id: 134, slug: 'raqqa', title: 'رقه' },
    { id: 135, slug: 'idlib', title: 'ادلب' },
    { id: 136, slug: 'daraa', title: 'درعا' },
    { id: 137, slug: 'sweida', title: 'سویداء' },
    { id: 138, slug: 'quneitra', title: 'قنیطره' },
    // Jordan
    { id: 139, slug: 'amman', title: 'عمان' },
    { id: 140, slug: 'irbid', title: 'اربد' },
    { id: 141, slug: 'zarqa', title: 'زرقاء' },
    { id: 142, slug: 'ajloun', title: 'عجلون' },
    { id: 143, slug: 'salt', title: 'سلط' },
    { id: 144, slug: 'al-karak', title: 'کرک' },
    { id: 145, slug: 'mafraq', title: 'مفرق' },
    { id: 146, slug: 'madaba', title: 'مادبا' },
    { id: 147, slug: 'muta', title: 'موته' },
    { id: 148, slug: 'tafilah', title: 'طفیله' },
    { id: 149, slug: 'maan', title: 'معان' },
    { id: 150, slug: 'aqaba', title: 'عقبه' },
    // Afghanistan
    { id: 151, slug: 'kabul', title: 'کابل' },
    { id: 152, slug: 'kandahar', title: 'قندهار' },
    { id: 153, slug: 'herat', title: 'هرات' },
    { id: 154, slug: 'mazar-i-sharif', title: 'مزارشریف' },
    { id: 155, slug: 'jalalabad', title: 'جلال‌آباد' },
    { id: 156, slug: 'balkh', title: 'بلخ' },
    { id: 157, slug: 'pul-e-khumri', title: 'پل‌خمری' },
    { id: 158, slug: 'nangarhar', title: 'ننگرهار' },
    { id: 159, slug: 'kunduz', title: 'قندوز' },
    { id: 160, slug: 'takhar', title: 'تخار' },
    { id: 161, slug: 'gardez', title: 'گردیز' },
    { id: 162, slug: 'faizabad', title: 'فیض‌آباد' },
    { id: 163, slug: 'lashkar-gah', title: 'لشکرگاه' },
    { id: 164, slug: 'zabul', title: 'زابل' },
    { id: 165, slug: 'ghazni', title: 'غزنی' },
    { id: 166, slug: 'farah', title: 'فراه' },
    { id: 167, slug: 'aibak', title: 'ایبک' },
    { id: 168, slug: 'maidan shahr', title: 'میدان شهر' },
    { id: 169, slug: 'panjshir', title: 'پنجشیر' },
    { id: 170, slug: 'bamyan', title: 'بامیان' },
    // China
    { id: 171, slug: 'beijing', title: 'پکن' },
    { id: 172, slug: 'tianjin', title: 'تیانجین' },
    { id: 173, slug: 'shijiazhuang', title: 'شیجیازوانگ' },
    { id: 174, slug: 'taiyuan', title: 'تایوان' },
    { id: 175, slug: 'huhhot', title: 'هوهوت' },
    { id: 176, slug: 'shenyang', title: 'شنیانگ' },
    { id: 177, slug: 'changchun', title: 'چانگچون' },
    { id: 178, slug: 'harbin', title: 'هاربین' },
    { id: 179, slug: 'shanghai', title: 'شانگهای' },
    { id: 180, slug: 'nanjing', title: 'نانجینگ' },
    { id: 181, slug: 'hangzhou', title: 'هانگجو' },
    { id: 182, slug: 'hefei', title: 'هفئی' },
    { id: 183, slug: 'fuzhou', title: 'فوجو' },
    { id: 184, slug: 'nanchang', title: 'نانچانگ' },
    { id: 185, slug: 'jinan', title: 'جینان' },
    { id: 186, slug: 'zhengzhou', title: 'ژنگجو' },
    { id: 187, slug: 'wuhan', title: 'ووهان' },
    { id: 188, slug: 'changsha', title: 'چانگشا' },
    { id: 189, slug: 'guangzhou', title: 'گوانگجو' },
    { id: 190, slug: 'nanning', title: 'نانینگ' },
    { id: 191, slug: 'haikou', title: 'هایکو' },
    { id: 192, slug: 'chongqing', title: 'چونگ‌چینگ' },
    { id: 193, slug: 'chengdu', title: 'چنگدو' },
    { id: 194, slug: 'guiyang', title: 'گوییانگ' },
    { id: 195, slug: 'kunming', title: 'کونمینگ' },
    { id: 196, slug: 'lhasa', title: 'لهاسا' },
    { id: 197, slug: 'xian', title: 'شیان' },
    { id: 198, slug: 'lanzhou', title: 'لانژو' },
    { id: 199, slug: 'xining', title: 'شینینگ' },
    { id: 200, slug: 'yinchuan', title: 'یینچوان' },
    { id: 201, slug: 'urumqi', title: 'اورومچی' },
    { id: 202, slug: 'taipei', title: 'تایپه' },
    // Canada
    { id: 203, slug: 'edmonton', title: 'ادمونتون' },
    { id: 204, slug: 'victoria', title: 'ویکتوریا' },
    { id: 205, slug: 'winnipeg', title: 'وینیپگ' },
    { id: 206, slug: 'fredericton', title: 'فردریکتون' },
    { id: 207, slug: 'st-johns', title: 'سنت جانز' },
    { id: 208, slug: 'halifax', title: 'هالیفکس' },
    { id: 209, slug: 'toronto', title: 'تورنتو' },
    { id: 210, slug: 'charlottetown', title: 'شارلوتاون' },
    { id: 211, slug: 'quebec-city', title: 'شهر کبک' },
    { id: 212, slug: 'regina', title: 'رجاینا' },
    { id: 213, slug: 'yellowknife', title: 'یلونایف' },
    { id: 214, slug: 'iqaluit', title: 'ایکالویت' },
    { id: 215, slug: 'whitehorse', title: 'وایت‌هورس' },
    // Pakistan
    { id: 216, slug: 'lahore', title: 'لاهور' },
    { id: 217, slug: 'karachi', title: 'کراچی' },
    { id: 218, slug: 'peshawar', title: 'پیشاور' },
    { id: 219, slug: 'quetta', title: 'کویته' },
    { id: 220, slug: 'gilgit', title: 'گیلگیت' },
    { id: 221, slug: 'islamabad', title: 'اسلام‌آباد' },
    { id: 222, slug: 'muzaffarabad', title: 'مظفرآباد' },
    { id: 223, slug: 'bajaur', title: 'باجور' },
    // India
    { id: 224, slug: 'amaravati', title: 'آماراواتی' },
    { id: 225, slug: 'itanagar', title: 'ایتاناگار' },
    { id: 226, slug: 'dispur', title: 'دیسپور' },
    { id: 227, slug: 'patna', title: 'پاتنا' },
    { id: 228, slug: 'raipur', title: 'رایپور' },
    { id: 229, slug: 'panaji', title: 'پاناجی' },
    { id: 230, slug: 'ahmedabad', title: 'احمدآباد' },
    { id: 231, slug: 'chandigarh', title: 'چندیگره' },
    { id: 232, slug: 'shimla', title: 'شیملا' },
    { id: 233, slug: 'ranchi', title: 'رانچی' },
    { id: 234, slug: 'bangalore', title: 'بنگالور' },
    { id: 235, slug: 'thiruvananthapuram', title: 'تیروواننتاپورام' },
    { id: 236, slug: 'bhopal', title: 'بوپال' },
    { id: 237, slug: 'mumbai', title: 'مومبای' },
    { id: 238, slug: 'imphal', title: 'ایمفال' },
    { id: 239, slug: 'shillong', title: 'شیلانگ' },
    { id: 240, slug: 'aizawl', title: 'آیزاول' },
    { id: 241, slug: 'kohima', title: 'کوهیما' },
    { id: 242, slug: 'bhubaneswar', title: 'بوباناسوار' },
    { id: 243, slug: 'chandigarh', title: 'چندیگره (پنجاب)' },
    { id: 244, slug: 'jaipur', title: 'جیپور' },
    { id: 245, slug: 'gangtok', title: 'گانگتاک' },
    { id: 246, slug: 'chennai', title: 'چنای' },
    { id: 247, slug: 'hyderabad', title: 'حیدرآباد' },
    { id: 248, slug: 'agartala', title: 'آگارتالا' },
    { id: 249, slug: 'lucknow', title: 'لکنهو' },
    { id: 250, slug: 'dehradun', title: 'دهرادون' },
    { id: 251, slug: 'kolkata', title: 'کلکته' },
    { id: 252, slug: 'port-blair', title: 'پورت بلر' },
    { id: 253, slug: 'chandigarh', title: 'چندیگره (هریانا)' },
    { id: 254, slug: 'silvassa', title: 'سیلواسا' },
    { id: 255, slug: 'daman', title: 'دامان' },
    { id: 256, slug: 'new-delhi', title: 'دهلی نو' },
    { id: 257, slug: 'kavaratti', title: 'کاواراتی' },
    { id: 258, slug: 'puducherry', title: 'پودوچری' },
    // North Korea
    { id: 259, slug: 'sinuiju', title: 'سینویجو' },
    { id: 260, slug: 'kaesong', title: 'کائه‌سونگ' },
    { id: 261, slug: 'chongjin', title: 'چونگجین' },
    { id: 262, slug: 'hamhung', title: 'هامهونگ' },
    { id: 263, slug: 'sariwon', title: 'ساریوان' },
    { id: 264, slug: 'hwangju', title: 'هوانگجو' },
    { id: 265, slug: 'wonsan', title: 'وونسان' },
    { id: 266, slug: 'nampo', title: 'نامپو' },
    { id: 267, slug: 'rason', title: 'راسون' },
    { id: 268, slug: 'chongju', title: 'چونگجو' },
    { id: 269, slug: 'kaesong', title: 'کائه‌سونگ (جنوبی)' },
    { id: 270, slug: 'pyongyang', title: 'پیونگ‌یانگ' },
    // South Korea
    { id: 271, slug: 'seoul', title: 'سئول' },
    { id: 272, slug: 'busan', title: 'بوسان' },
    { id: 273, slug: 'daegu', title: 'دائگو' },
    { id: 274, slug: 'incheon', title: 'اینچئون' },
    { id: 275, slug: 'gwangju', title: 'گوانگجو' },
    { id: 276, slug: 'daejeon', title: 'دائجون' },
    { id: 277, slug: 'ulsan', title: 'اولسان' },
    { id: 278, slug: 'suwon', title: 'سووون' },
    { id: 279, slug: 'chuncheon', title: 'چونچئون' },
    { id: 280, slug: 'cheongju', title: 'چونگجو' },
    { id: 281, slug: 'jeonju', title: 'جئونجو' },
    { id: 282, slug: 'jeonju', title: 'جئونجو (جنوبی)' },
    { id: 283, slug: 'gwangju', title: 'گوانگجو (جنوبی)' },
    { id: 284, slug: 'andong', title: 'آندونگ' },
    { id: 285, slug: 'daegu', title: 'دائگو (شمالی)' },
    { id: 286, slug: 'jeju', title: 'جزیره جیجو' },
    // Japan
    { id: 287, slug: 'sapporo', title: 'ساپورو' },
    { id: 288, slug: 'aomori', title: 'آئوموری' },
    { id: 289, slug: 'morioka', title: 'موریوکا' },
    { id: 290, slug: 'sendai', title: 'سندای' },
    { id: 291, slug: 'akita', title: 'آکیتا' },
    { id: 292, slug: 'yamagata', title: 'یاماگاتا' },
    { id: 293, slug: 'fukushima', title: 'فوکوشیما' },
    { id: 294, slug: 'mito', title: 'میتو' },
    { id: 295, slug: 'utsunomiya', title: 'اوتسونومیا' },
    { id: 296, slug: 'maebashi', title: 'مائه‌باشی' },
    { id: 297, slug: 'saitama', title: 'سایتاما' },
    { id: 298, slug: 'chiba', title: 'چیبا' },
    { id: 299, slug: 'tokyo', title: 'توکیو' },
    { id: 300, slug: 'yokohama', title: 'یوکوهاما' },
    { id: 301, slug: 'niigata', title: 'نیگاتا' },
    { id: 302, slug: 'toyama', title: 'تویاما' },
    { id: 303, slug: 'kanazawa', title: 'کانازاوا' },
    { id: 304, slug: 'fukui', title: 'فوکوئی' },
    { id: 305, slug: 'kofu', title: 'کوفو' },
    { id: 306, slug: 'nagano', title: 'ناگانو' },
    { id: 307, slug: 'gifu', title: 'گیفو' },
    { id: 308, slug: 'shizuoka', title: 'شیزوئوکا' },
    { id: 309, slug: 'nagoya', title: 'ناگویا' },
    { id: 310, slug: 'tSuzuka', title: 'تسوزوکا' },
    { id: 311, slug: 'ohtsu', title: 'اوتسو' },
    { id: 312, slug: 'kyoto', title: 'کیوتو' },
    { id: 313, slug: 'osaka', title: 'اوزاکا' },
    { id: 314, slug: 'kobe', title: 'کوبه' },
    { id: 315, slug: 'nara', title: 'نارا' },
    { id: 316, slug: 'wakayama', title: 'واکایاما' },
    { id: 317, slug: 'tottori', title: 'توتوری' },
    { id: 318, slug: 'matsue', title: 'ماتسوئه' },
    { id: 319, slug: 'okayama', title: 'اوکایاما' },
    { id: 320, slug: 'hiroshima', title: 'هیروشیما' },
    { id: 321, slug: 'yamaguchi', title: 'یاماگوچی' },
    { id: 322, slug: 'tokushima', title: 'توکوشیما' },
    { id: 323, slug: 'kagawa', title: 'کاگاوا' },
    { id: 324, slug: 'matsuyama', title: 'ماتسویاما' },
    { id: 325, slug: 'kochi', title: 'کوچی' },
    { id: 326, slug: 'fukuoka', title: 'فوکوئوکا' },
    { id: 327, slug: 'saga', title: 'ساگا' },
    { id: 328, slug: 'nagasaki', title: 'ناگازاکی' },
    { id: 329, slug: 'kumamoto', title: 'کوماموتو' },
    { id: 330, slug: 'oita', title: 'اویتا' },
    { id: 331, slug: 'miyazaki', title: 'میازاکی' },
    { id: 332, slug: 'kagoshima', title: 'کاگوشیما' },
    { id: 333, slug: 'naha', title: 'ناها' },
    // Taiwan
    { id: 334, slug: 'taipei', title: 'تایپه (پایتخت)' },
    { id: 335, slug: 'kaohsiung', title: 'کائوشیونگ' },
    { id: 336, slug: 'taichung', title: 'تایچونگ' },
    { id: 337, slug: 'tainan', title: 'تاینان' },
    { id: 338, slug: 'taoyuan', title: 'تائویوان' },
    { id: 339, slug: 'new-taipei', title: 'تایپه جدید' },
    { id: 340, slug: 'keelung', title: 'کیلونگ' },
    { id: 341, slug: 'hualien', title: 'هوالیان' },
    { id: 342, slug: 'miaoli', title: 'میائولی' },
    { id: 343, slug: 'chiayi', title: 'جیایی' },
    { id: 344, slug: 'changhua', title: 'چانگهوا' },
    { id: 345, slug: 'pingtung', title: 'پینگتونگ' },
    { id: 346, slug: 'yilan', title: 'یی‌لان' },
    { id: 347, slug: 'nantou', title: 'نانتو' },
    { id: 348, slug: 'chiayi', title: 'جیایی (شهر)' },
    { id: 349, slug: 'keelung', title: 'کیلونگ (شهر)' },
    { id: 350, slug: 'pingdong', title: 'پینگدونگ' },
    { id: 351, slug: 'hsinchu', title: 'هسینچو' },
    // Lebanon
    { id: 352, slug: 'beirut', title: 'بیروت' },
    { id: 353, slug: 'baabda', title: 'بعبدا' },
    { id: 354, slug: 'tripoli', title: 'طرابلس' },
    { id: 355, slug: 'halba', title: 'حلبا' },
    { id: 356, slug: 'zahle', title: 'زحله' },
    { id: 357, slug: 'baalbek', title: 'بعلبک' },
    { id: 358, slug: 'sidon', title: 'صیدا' },
    { id: 359, slug: 'nabatieh', title: 'نبطیه' },
];

export function getCity(key) {
    if (typeof key === 'number') {
        return CITIES.find(city => city.id === key) || null;
    }
    if (typeof key === 'string') {
        return CITIES.find(city => city.slug === key.trim()) || null;
    }
    return null;
}